<template>
  <div >
    <!-- 这是规则设定页面 #Test.vue -->

    <myform
      ref='editUser'
      :viewobj="{
        addUser  : [ '新增用户信息', 'el-icon-circle-plus' ],
        editUser : [ '修改用户信息', 'el-icon-edit-outline'],
        $succeed$: queryCommon
      }"
      @show="_log('弹框显示了!')"
      @close='$form("editUser","reset")'
    >

      <template v-slot:authParams='{Myformdata}' >
        <el-input
          v-model="Myformdata.authParams" type="textarea" style='width:100%;'
          :autosize='{minRows:1}'
          placeholder='可在此输入接口参数(如果有多个参数,请换行填写)'
         />
      </template>

      <template v-slot:usex='{Myformdata}'>
        <el-radio-group
          v-set:usex='3'
          v-model='Myformdata.usex'>
          <el-radio :label='1'>男</el-radio>
          <el-radio :label='2'>女</el-radio>
          <el-radio :label='3'>保密</el-radio>
        </el-radio-group>
      </template>
      
      <template v-slot >
        <el-tree
          ref='ElTree'
          :data='getRoleAuthListByProject_data.data||[]'
          show-checkbox
          check-on-click-node
          @check="Myformdata.authListString = arguments[1].checkedKeys + ''"

          node-key='authId'
          :props='{
            children: "children",
            label: "authName"
          }'

          highlight-current
        >
        </el-tree>
      </template>

      <!-- 隐藏指定字段 -->
      <hide slot='id'/>
      <hide slot="auditResult"/>
      <hide slot="applicationId"/>
      <hide slot="applicationUserId"/>

    </myform>

  </div>
</template>
<script>

// let collapseMenu;
export default {
  // components: {
  //   headers,
  //   navs,
  // },
  
  data() {
    return {

    };
  },

  created() {
    
  },

  activated() {
    
  },

  mounted() {
    
  },
};

</script>


<style xscoped >

</style>



// WEBPACK FOOTER //
// src/views/#Test/#Test.vue